goog.provide('el8.appchart.refpanel.legal');

goog.require('el8.model.base');
goog.require('el8.appchart.metrics');
goog.require('el8.appchart.mgr.notes');
goog.require('el8.ptdata.fetchById');
goog.require('el8.appchart.permissions');
goog.require('el8.template.appchart.refpanel.legal');


el8.appchart.refpanel.legal = (function() {

    var reportOnFirstLoad = el8.appchart.metrics.getChartLoadCallback('legal');

    return new el8.uiwidget.Component({
        dataRenderers: [
            {
                entitySet: el8.ptdata.legalReportSetRP,
                listenFn: function() {
                    var allLegal = el8.ptdata.legalReportSetRP.all();
                    $('#legal-reports-summary').replaceWith($(
                        el8.template.appchart.refpanel.legal.summary({
                            items: allLegal.map(el8.model.toSoyMapFn)
                        })
                    ));
                    if (allLegal.length) {
                        $('.le-empty-entry', '#legal-history-list').remove();
                    }

                    function getMenu(item) {
                        var menu = [];
                        if (el8Globals.TEASE) {
                            return menu;
                        }
                        menu.push({
                            actionText: 'View Report',
                            actionFn: function() {
                                el8.appchart.dialog.reports.show({ item: item });
                            }
                        });
                        menu.push({
                            actionText: 'Export to Note',
                            actionFn: function() {
                                el8.appchart.mgr.notes.addReference({item: item});
                            }
                        });
                        return menu;
                    }

                    var $legalReportsSummary = $($('#legal-reports-summary')[0]);

                    $legalReportsSummary.on('click', '.details-trigger', function() {
                        var itemId = $(this).data('id');
                        el8.appchart.showItemDetail(itemId);
                    });

                    $legalReportsSummary.on('click', '.more-actions-trigger', function() {
                        var obj = $(this);
                        var itemId = obj.data('id');
                        var item = el8.ptdata.fetchById(itemId);
                        el8.appchart.refpanel.actionsMenu.display(obj, item, {top: 14, left: 20}, getMenu(item));
                        return false;
                    });

                    reportOnFirstLoad();
                }
            }
        ]
    });

})();
